import { useEffect } from 'react';
import { Checkbox } from '@/components/design-system/Checkbox';
import {
  FormControl,
  FormItem,
  FormLabel,
} from '@/components/design-system/Form';

interface Choice {
  recordValue: string;
  content: string;
  ordinal: number;
  errorMessage?: string | null;
}

interface ConsentCheckboxProps {
  choices: Choice[];
  values: Record<string, boolean>;
  onChange: (values: Record<string, boolean>) => void;
  onValidationChange: (isValid: boolean) => void;
}

export const ConsentCheckbox = ({ 
  choices, 
  values, 
  onChange, 
  onValidationChange 
}: ConsentCheckboxProps) => {
  const handleCheckboxChange = (recordValue: string, checked: boolean) => {
    const newValues = {
      ...values,
      [recordValue]: checked
    };
    onChange(newValues);
  };

  useEffect(() => {
    const requiredChoices = choices.filter(choice => !choice.content.includes('optional'));
    const hasRequiredSelections = requiredChoices.every(choice => values[choice.recordValue]);
    onValidationChange(hasRequiredSelections);
  }, [values, choices, onValidationChange]);

  return (
    <div className="mt-8 flex flex-col gap-4">
      {choices.map((choice, idx) => (
        <FormItem key={choice.ordinal} className="flex items-center gap-x-3">
          <FormControl>
            <Checkbox
              id={`c${idx}`}
              checked={values[choice.recordValue] || false}
              onCheckedChange={(checked) => handleCheckboxChange(choice.recordValue, checked as boolean)}
            />
          </FormControl>
          <FormLabel
            htmlFor={`c${idx}`}
            className="text-sm font-medium leading-none !mt-0"
          >
            {choice.content}
          </FormLabel>
        </FormItem>
      ))}
    </div>
  );
}; 